export default __webpack_public_path__ + "static/media/project-4.7245813e.jpg";